import { gql } from "@apollo/client"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import { DestroyGrantInput, DestroyGrantPayload } from "@oysterhr/schema"

export const MUTATION = gql`
  mutation DestroyEquityGrant($equityGrantId: ID!) {
    destroyEquityGrant(input: { equityGrantId: $equityGrantId }) {
      errors
    }
  }
`

export default (options?: InjectedOptions<DestroyGrantPayload, DestroyGrantInput>) =>
  useMutation<DestroyGrantPayload, DestroyGrantInput>(MUTATION, options)
